import TagManager from 'react-gtm-module';

import { getCustomerLoods5Id } from '../@account/Customer/CustomerService';
import { ecommerceEvents, GTMEvent } from './GTM';

const isEcommerceEvent = (eventType: GTMEvent): boolean => ecommerceEvents.includes(eventType);

export const initializeTagManager = (dataLayer: Record<string, string>): void => {
    const gtmId = process.env.REACT_APP_GTM_ID;

    if (gtmId) {
        TagManager.initialize({
            gtmId,
            dataLayer,
        });
    }
};

export const sendGTMEvent = <T = Record<string, unknown>>(event: GTMEvent, data?: T): void => {
    TagManager.dataLayer({
        dataLayer: {
            ecommerce: null,
        },
    });

    const userId = getCustomerLoods5Id();

    const baseDataLayer = {
        event,
        ...(userId && { user_id: userId }),
    };

    const normalDataLayer = {
        ...baseDataLayer,
        ...data,
    };

    const ecommerceDataLayer = {
        ...baseDataLayer,
        ecommerce: data,
    };

    const payload = isEcommerceEvent(event)
        ? ecommerceDataLayer
        : normalDataLayer;

    TagManager.dataLayer({ dataLayer: payload });
};
